var map = {
	"./banhanguytin/4.png": "5670",
	"./cacung/4.png": "59f3",
	"./chuyencan/4.png": "8095",
	"./daigiadataha/4.png": "d2f1",
	"./duhanhgia/4.png": "164a",
	"./thanhsanma/4.png": "8918"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cb6";